import { render } from "./arrange.vue?vue&type=template&id=5da28bce&scoped=true"
import script from "./arrange.vue?vue&type=script&lang=js"
export * from "./arrange.vue?vue&type=script&lang=js"

import "./arrange.vue?vue&type=style&index=0&id=5da28bce&scoped=true&lang=css"

import exportComponent from "/home/stagging/consillium/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5da28bce"]])

export default __exports__